import React from 'react'
import groupBy from 'lodash/groupBy'
import keyBy from 'lodash/keyBy'
import isEmpty from 'lodash/isEmpty'
import intersection from 'lodash/intersection'
import { AppliedModifier } from 'components/Orders/Info/type'

interface Props {
  orderQuantity: number
  appliedModifiers: AppliedModifier[]
  arrangement?: { [key: string]: string }
}

const AppliedModifiers = ({
  appliedModifiers,
  arrangement,
  orderQuantity
}: Props) => {
  if (appliedModifiers.length > 0) {
    return (
      <ModifierGroups
        appliedModifiers={appliedModifiers}
        arrangement={arrangement}
        orderQuantity={orderQuantity}
      />
    )
  } else {
    return <span>N/A</span>
  }
}

const ModifierGroups = ({
  orderQuantity,
  appliedModifiers,
  arrangement
}: Props) => {
  // applied modifiers grouped by modifier group id
  const groupedModifiers = groupBy(
    appliedModifiers,
    (item) => item.modifier_group.id
  )

  // applied modifier group ids
  const groupKeys = Object.keys(groupedModifiers)

  // product modifier group arrangement
  const groupArrangement =
    arrangement && !isEmpty(arrangement)
      ? Object.values(arrangement)
      : groupKeys
  const arrangementMatchedGroups = intersection(groupArrangement, groupKeys)

  const nonArrangedGroupIds = groupKeys.filter(
    (groupId: string) => !arrangementMatchedGroups.includes(groupId)
  )

  const totalArrangement = [...arrangementMatchedGroups, ...nonArrangedGroupIds]
  return (
    <>
      {totalArrangement.map((groupId, index) => {
        const modifiers = groupedModifiers[groupId]
        const { modifier_group } = modifiers[0]
        return (
          <div data-testid='appliedModifiers' key={index}>
            <span>{modifier_group.name}:</span>
            <br />
            <Modifiers
              key={index}
              orderQuantity={orderQuantity}
              appliedModifiers={modifiers}
              arrangement={modifier_group.modifier_arrangement}
            />
          </div>
        )
      })}
    </>
  )
}

const Modifiers = ({ orderQuantity, appliedModifiers, arrangement }: Props) => {
  const groupedItems = keyBy(appliedModifiers, (item) => item.modifier.id)
  const itemKeys = Object.keys(groupedItems)

  const itemArrangement =
    arrangement && !isEmpty(arrangement) ? Object.values(arrangement) : itemKeys

  const excludedItems = itemKeys.filter(
    (itemId: string) => !itemArrangement.includes(itemId)
  )

  const totalArrangement = [...itemArrangement, ...excludedItems]
  return (
    <>
      {totalArrangement.map((itemId: string, index: number) => {
        const item = groupedItems[itemId]
        return (
          item && (
            <>
              <span key={index}>
                {item.quantity * orderQuantity} x {item.modifier.name}
              </span>
              <br />
            </>
          )
        )
      })}
    </>
  )
}

export default AppliedModifiers
